import { render, staticRenderFns } from "./ViewNotificationBodyColumnRenderer.vue?vue&type=template&id=7a2e6562&"
import script from "./ViewNotificationBodyColumnRenderer.vue?vue&type=script&lang=js&"
export * from "./ViewNotificationBodyColumnRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports